import React, { Component, Suspense } from 'react';
import Layout from './components/Layout/';
import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './Apps.scss';

import NotFound from './pages/NotFound';
import Bp from './pages/Case Studies/Subpages/Bp';
import Inttix from './pages/Case Studies/Subpages/Inttix';
import Canvas from './pages/Canvas/Canvas';
import Kobo from './pages/Case Studies/Subpages/Kobo';
import Liveli from './pages/Case Studies/Subpages/Liveli';
import Geria from './pages/Case Studies/Subpages/Geria';
import Jaguar from './pages/Case Studies/Subpages/Jaguar';
import Microsoft from './pages/Microsoft/Microsoft';
import CaseList from './pages/Case Studies/CaseList';
import IcanTutors from './pages/Case Studies/Subpages/IcanTutors';
import IlearnCloud from './pages/Case Studies/Subpages/Ilearncloud';
import Fintech from './pages/Events/Fintech Fusion/Fintech';
import Consultation from './pages/ScheduleConsultation/Consultation';
import AWSManagedCloud from './pages/Solutions/AWSManagedCloud';
import AWSMaturityService from './pages/Maturity Service/MaturityService';

// blog pages
import BlogFourteen from './pages/Blog/blog_fourteen';
import BlogFifteen from './pages/Blog/blog_fifteen';
import BlogSixteen from './pages/Blog/blog_sixteen';
import BlogSeventeen from './pages/Blog/blog_seventeen';
import BlogEighteen from './pages/Blog/blog_eighteen';
import BlogNineteen from './pages/Blog/blog_nineteen';
import BlogTwenty from './pages/Blog/blog_twenty';
import BlogTwentyOne from './pages/Blog/blog_twentyone';
import BlogTwentyTwo from './pages/Blog/blog_twentytwo';
import BlogTwentyThree from './pages/Blog/blog_twentythree';
import BlogTwentyFour from './pages/Blog/blog_twentyfour';
import BlogTwentyFive from './pages/Blog/blog_twentyfive';
import BlogTwentySix from './pages/Blog/blog_twentysix';
import BlogTwentySeven from './pages/Blog/blog_twentyseven';
import BlogTwentyEight from './pages/Blog/blog_twentyeight';
import BlogTwentyNine from './pages/Blog/blog_twentynine';
import BlogThirty from './pages/Blog/blog_thirty';
import BlogThirtyOne from './pages/Blog/blog_thirtyone';
import BlogThirtyTwo from './pages/Blog/blog_thirtytwo';
import BlogThirtyThree from './pages/Blog/blog_thirtyThree';
import BlogThirtyFour from './pages/Blog/blog_thirtyfour';
import BlogThirtyFive from './pages/Blog/blog_thirtyFive';
import BlogThirtySix from './pages/Blog/blog_thirtySix';
import BlogThirtySeven from './pages/Blog/blog_thirtySeven';
import BlogThirtyEight from './pages/Blog/blog_thirtyEight';
import BlogThirtyNine from './pages/Blog/blog_thirtyNine';
import BlogForty from './pages/Blog/blog_forty';
import BlogFortyOne from './pages/Blog/blog_fortyOne';
import BlogFortyTwo from './pages/Blog/blog_fourtyTwo';
import PageBlogFortyFive from './pages/Blog/blog_fortyFive';
import PageBlogFortyFour from './pages/Blog/blog_fortyFour';
import PageBlogFortyThree from './pages/Blog/blog_fortyThree';
import GtbPensions from './pages/Case Studies/Subpages/gtb/GtbPensions';
import BillyRonks from './pages/Case Studies/Subpages/BillyRonks';
import Mkobo from './pages/Case Studies/Subpages/Mkobo';
import PhastPay from './pages/Case Studies/Subpages/Phastpay';
import Alarrt from './pages/Case Studies/Subpages/Alarrt';
import BlogFortySeven from './pages/Blog/blog_fortySeven';
const BlogList = React.lazy(() => import('./pages/Blog/BlogList'));
const Blog_One = React.lazy(() => import('./pages/Blog/blog_one'));
const Blog_two = React.lazy(() => import('./pages/Blog/blog_two'));
const Blog_five = React.lazy(() => import('./pages/Blog/blog_five'));
const Blog_six = React.lazy(() => import('./pages/Blog/blog_six'));
const Blog_seven = React.lazy(() => import('./pages/Blog/blog_seven'));
const Blog_eight = React.lazy(() => import('./pages/Blog/blog_eight'));
const Blog_nine = React.lazy(() => import('./pages/Blog/blog_nine'));
const Blog_three = React.lazy(() => import('./pages/Blog/blog_three'));
const Blog_ten = React.lazy(() => import('./pages/Blog/blog_ten'));
const Blog_eleven = React.lazy(() => import('./pages/Blog/blog_eleven'));
const Blog_twelve = React.lazy(() => import('./pages/Blog/blog_twelve'));
const Blog_thirteen = React.lazy(() => import('./pages/Blog/blog_thirteen'));
const BlogFortySix = React.lazy(() => import('./pages/Blog/blog_fortySix'));

// partnership pages
const Ec2 = React.lazy(() => import('./pages/aws_partnership/AWSEC2/Ec2'));
const RDSReady = React.lazy(() => import('./pages/aws_partnership/RDSReady'));
const AWSLambda = React.lazy(() => import('./pages/aws_partnership/AWSLambda'));
const Transfer = React.lazy(() =>
    import('./pages/aws_partnership/AWSTransfer/Transfer')
);
const CloudFront = React.lazy(() =>
    import('./pages/aws_partnership/AWSCloudFront/CloudFront')
);
const DataAnalytics = React.lazy(() =>
    import('./pages/aws_partnership/DataAnalytics/DataAnalytics')
);
const AWSDynamoDb = React.lazy(() =>
    import('./pages/aws_partnership/AWSDynamo/AWSDynamo')
);
const CloudResouce = React.lazy(() =>
    import('./pages/aws_partnership/CloudResouce/CloudResouce')
);
const SecurityCompliance = React.lazy(() =>
    import('./pages/aws_partnership/securityCompliance/SecurityCompliance')
);
const AWSWellArchitected = React.lazy(() =>
    import('./pages/aws_partnership/Well Architected/AWSWellArchitected')
);

// Course Ads
const AWSAds = React.lazy(() => import('./pages/Course Ads/AWSCertifiedAds'));
const PowerBiAds = React.lazy(() => import('./pages/Course Ads/PowerBiAds'));
const MicrosoftAzureAds = React.lazy(() =>
    import('./pages/Course Ads/MicrosoftAzureAds')
);
const Contact = React.lazy(() => import('./pages/Contact'));
const ScheduleDemo = React.lazy(() => import('./pages/ScheduleDemo'));
const ProfessionalServies = React.lazy(() =>
    import('./pages/Professional Service/ProfessionalServices')
);
const Pricing = React.lazy(() => import('./pages/Pricing'));
const AWSPartnership = React.lazy(() =>
    import('./pages/AWSPartnership/AWSPartnership')
);
const Knowledge = React.lazy(() => import('./pages/Knowledge'));
const PagePrivacy = React.lazy(() => import('./pages/Utility/PagePrivacy'));
const PageTerms = React.lazy(() => import('./pages/Utility/PageTerms'));
const CookiePolicyMore = React.lazy(() =>
    import('./pages/Utility/CookiePolicyMore')
);

const LandingPage = React.lazy(() =>
    import('./pages/Landing Page/LandingPage')
);
const CloudMigration = React.lazy(() =>
    import('./pages/aws_partnership/Cloud Migration/MainPage')
);
const Glow = React.lazy(() => import('./pages/Glow'));

const Training = React.lazy(() => import('./pages/Training/Training'));
const FoundersLab = React.lazy(() =>
    import('./pages/Founders Lab/FoundersLab')
);
const TrainingContact = React.lazy(() => import('./pages/Training/Contact'));

// Events Pages
const EventsPage = React.lazy(() => import('./pages/Events/Events'));
const Events_One = React.lazy(() => import('./pages/Events/Events1'));
const Events_Two = React.lazy(() => import('./pages/Events/Events2'));
const Events_Three = React.lazy(() => import('./pages/Events/Events3'));
const Events_Four = React.lazy(() => import('./pages/Events/Events4'));
const Events_Five = React.lazy(() => import('./pages/Events/Events5'));

// White Paper Pages
const WhitePaper = React.lazy(() => import('./pages/White Paper/WhitePaper'));
const WhitePaperOne = React.lazy(() =>
    import('./pages/White Paper/WhitePaperOne')
);
const WhitePaperTwo = React.lazy(() =>
    import('./pages/White Paper/WhitepaperTwo')
);

// Course Description
const AWSCertified = React.lazy(() =>
    import('./pages/coursedescription/AwsCertifiedCloudPractitionerDesc')
);
const BigDataAdvanced = React.lazy(() =>
    import('./pages/coursedescription/BigDataAdvancedHadoopDesc')
);
const BigDataBegineer = React.lazy(() =>
    import('./pages/coursedescription/BigDataBeginnerHadoopDesc')
);
const BigDataSpark = React.lazy(() =>
    import('./pages/coursedescription/BigDataWithSparkDesc')
);
const Devops = React.lazy(() => import('./pages/coursedescription/DevopsDesc'));
const ContinuousIntegration = React.lazy(() =>
    import('./pages/coursedescription/CIJenkinsDesc')
);
const CoreJava = React.lazy(() =>
    import('./pages/coursedescription/CoreJavaEssentialsDesc')
);
const Database = React.lazy(() =>
    import('./pages/coursedescription/DatabasePostgreSQLDesc')
);
const DataScience = React.lazy(() =>
    import('./pages/coursedescription/DataScienceAndMLWithRDesc')
);
const EdgeComputing = React.lazy(() =>
    import('./pages/coursedescription/EdgeComputingDesc')
);
const Leveraging = React.lazy(() =>
    import('./pages/coursedescription/LeveragingCloudDesc')
);
const MachineLearning = React.lazy(() =>
    import('./pages/coursedescription/MachineLearningDesc')
);
const NoSQL = React.lazy(() =>
    import('./pages/coursedescription/NoSQLAndMongoDBDesc')
);
const Networking = React.lazy(() =>
    import('./pages/coursedescription/NetworkingCCNADesc')
);
const Python = React.lazy(() =>
    import('./pages/coursedescription/PythonForDataScienceDesc')
);
const UnixShell = React.lazy(() =>
    import('./pages/coursedescription/UnixShellScriptingDesc')
);
const Git = React.lazy(() =>
    import('./pages/coursedescription/VersionControlDesc')
);
const AutomatedTesting = React.lazy(() =>
    import('./pages/coursedescription/AutomatedTestingDesc')
);
const Kubernetes = React.lazy(() =>
    import('./pages/coursedescription/Kubernetesdesc')
);
const MicrosoftAzure = React.lazy(() =>
    import('./pages/coursedescription/MicrosoftAzure')
);
const PowerBiDesc = React.lazy(() =>
    import('./pages/coursedescription/PowerBiDesc')
);
// Backup & Restore
const Backup = React.lazy(() => import('./pages/Backup & Restore/Main'));
// Innovation
const Innovation = React.lazy(() => import('./pages/Innovation/Innovation'));
const Technologies = React.lazy(() =>
    import('./pages/Technologies/Technologies')
);
const SplashScreen = React.lazy(() => import('./pages/SplashScreen'));

// Solutions
const DevopsPage = React.lazy(() => import('./pages/Solutions/DevOps'));
const PressRelease = React.lazy(() =>
    import('./pages/PressRelease/PressRelease')
);

const routes = [
    { path: '/', element: LandingPage },
    { path: '/training', element: Training },
    { path: '/events', element: EventsPage },
    { path: '/founders-lab', element: FoundersLab },
    { path: '/edge-computing', element: Events_One },
    { path: '/contact-training', element: TrainingContact },
    { path: '/innovation-challenge', element: Innovation },
    {
        path: '/leveraging-cloud-solutions-for-business-growth',
        element: Events_Two,
    },
    {
        path: '/getting-your-security-foundations-right',
        element: Events_Three,
    },
    { path: '/cloud-security-and-requirements', element: Events_Four },
    { path: '/cloud-modernization', element: Events_Five },
    { path: '/backup-and-restore', element: Backup },
    { path: '/aws-cloud-practitioner', element: AWSCertified },
    { path: '/big-data-advanced-hadoop-ecosystem', element: BigDataAdvanced },
    { path: '/big-data-beginner-hadoop-ecosystem', element: BigDataBegineer },
    { path: '/big-data-with-spark', element: BigDataSpark },
    { path: '/devops-with-ansible', element: Devops },
    {
        path: '/intro-to-continous-integration-ci-jenkins',
        element: ContinuousIntegration,
    },
    { path: '/java-programming', element: CoreJava },
    { path: '/database-and-postgresql', element: Database },
    { path: '/edge-computing-driving', element: EdgeComputing },
    { path: '/leveraging-cloud', element: Leveraging },
    { path: '/machine-learning', element: MachineLearning },
    { path: '/non-relational-database', element: NoSQL },
    { path: '/networking-ccna', element: Networking },
    { path: '/python-for-data-science', element: Python },
    { path: '/unix-shell-scripting', element: UnixShell },
    { path: '/powerbi-analytics', element: PowerBiDesc },
    { path: '/git-and-github', element: Git },
    { path: '/kubernetes', element: Kubernetes },
    { path: '/automated-software-testing', element: AutomatedTesting },
    { path: '/data-science-and-ml', element: DataScience },
    { path: '/microsoft-azure-fundamentals', element: MicrosoftAzure },
    { path: '/whitepaper', element: WhitePaper },
    {
        path: '/is-migrating-to-the-cloud-chasing-the-clouds',
        element: WhitePaperOne,
    },
    { path: '/how-secure-is-your-data', element: WhitePaperTwo },
    { path: '/cloud-migration', element: CloudMigration },
    { path: '/glow', element: Glow },
    { path: '/pricing', element: Pricing },
    { path: '/aws-partnership', element: AWSPartnership },
    { path: '/aws-dynamo-db', element: AWSDynamoDb },
    { path: '/security-compliance', element: SecurityCompliance },
    { path: '/microsoft-on-aws', element: Microsoft },
    { path: '/cloud-resource-managament', element: CloudResouce },
    { path: '/amazon-cloudfront-delivery', element: CloudFront },
    { path: '/amazon-ec2', element: Ec2 },
    { path: '/aws-transfer-family', element: Transfer },
    {
        path: '/aws-well-architected-framework-alignment',
        element: AWSWellArchitected,
    },
    { path: '/knowledge', element: Knowledge },
    { path: '/contact-us', element: Contact },
    { path: '/schedule-demo', element: ScheduleDemo },
    { path: '/page-privacy', element: PagePrivacy },
    { path: '/page-terms', element: PageTerms },
    { path: '/cookie-policy-more', element: CookiePolicyMore },
    {
        path: '/cloudplexo-achieves-aws-isv-partner-status-in-aws-partner-network',
        element: Blog_One,
    },
    {
        path: '/can-smes-benefit-from-cloud-cost-management-tools',
        element: Blog_three,
    },
    {
        path: '/ways-companies-can-save-on-their-cloud-computing-costs',
        element: Blog_two,
    },
    {
        path: '/the-benefits-of-building-a-cloud-native-company',
        element: Blog_five,
    },
    { path: '/aws-well-architected-framework-alignment', element: Blog_six },
    {
        path: '/aws-cost-optimization-while-achieving-your-desired-business',
        element: Blog_eight,
    },
    {
        path: '/rightsizing-recommendation-an-approach-to-save-on-your-aws-cost',
        element: Blog_nine,
    },
    { path: '/aws-service-limits-monitoring', element: Blog_seven },
    {
        path: '/how-does-the-cloud-enable-agile-digital-transformations',
        element: Blog_ten,
    },
    { path: '/will-cloud-computing-rule-the-world', element: Blog_eleven },
    { path: '/why-build-on-the-cloud', element: Blog_twelve },
    {
        path: '/what-cloud-optimisation-is-and-why-it-matters',
        element: Blog_thirteen,
    },
    {
        path: '/introduction-to-writing-serverless-application',
        element: BlogFourteen,
    },
    { path: '/blog', element: BlogList },

    { path: '/professional-services', element: ProfessionalServies },
    { path: '/technologies', element: Technologies },
    { path: '/power-bi-contact-form', element: PowerBiAds },
    { path: '/aws-contact-form', element: AWSAds },
    { path: '/microsoft-azure-contactform', element: MicrosoftAzureAds },
    { path: '/data-analytics', element: DataAnalytics },
    { path: '/download-canvas', element: Canvas },
    { path: '/schedule-consultation', element: Consultation },
    { path: '/devops-as-a-service', element: DevopsPage },
    { path: '/press-release', element: PressRelease },
    { path: '/aws-managed-cloud', element: AWSManagedCloud },
    { path: '/fintech-fusion-summit', element: Fintech },
    { path: '/video-detection-with-aws-rekognition', element: BlogSeventeen },
    {
        path: '/aws-lambda-introduction-to-writing-serverless-applications',
        element: BlogFifteen,
    },
    {
        path: '/aws-sam-build-test-and-deploy-serveless-applications',
        element: BlogSixteen,
    },
    { path: '/10-aws-services', element: BlogEighteen },
    {
        path: '/continuous-deployment-using-github-actions',
        element: BlogNineteen,
    },
    { path: '/unravelling-cloud-billing-solutions', element: BlogTwenty },
    {
        path: '/cloudplexo-ascends-to-advanced-tier-consulting-&-technology-partner-with-aws',
        element: BlogTwentyOne,
    },
    { path: '/hands-on-with-aws-comprehend', element: BlogTwentyTwo },
    { path: '/hands-on-with-aws-transcribe', element: BlogTwentyThree },
    { path: '/hands-on-aws-polly', element: BlogTwentyFour },
    {
        path: "a-beginner's-guide-to-aws-fargate-and-ec2",
        element: BlogTwentyFive,
    },
    {
        path: '/amazon-api-gateway-service-delivery-enhancing-efficiency-and-connectivity',
        element: BlogTwentySix,
    },
    {
        path: '/cloudplexo-receives-aws-lambda-service-delivery-designation',
        element: BlogTwentySeven,
    },
    {
        path: '/advanced-document-processing-with-aws-textract',
        element: BlogTwentyEight,
    },
    {
        path: '/strategies-to-achieving-business-agility-with-cloud-native-culture',
        element: BlogTwentyNine,
    },
    {
        path: '/best-practices-building-scalable-apps-with-serverless-architecture',
        element: BlogThirty,
    },
    {
        path: '/best-practices-to-ensuring-data-resilience-with-cloud-native-backup',
        element: BlogThirtyOne,
    },
    {
        path: '/unlocking-efficiency-and-innovation-with-cloudplexo',
        element: BlogThirtyTwo,
    },
    {
        path: '/designing-well-architected-aws-solutions',
        element: BlogThirtyThree,
    },
    {
        path: '/effective-monitoring-of-aws-service-limits',
        element: BlogThirtyFour,
    },
    {
        path: '/maximizing-cloud-benefits-for-businesses',
        element: BlogThirtyFive,
    },
    {
        path: '/optimizing-cloud-costs-for-businesses-with-cloudplexo',
        element: BlogThirtySix,
    },
    {
        path: '/strategies-to-optimizing-aws-costs-for-business-efficiency',
        element: BlogThirtySeven,
    },
    {
        path: '/unlocking-the-power-of-aws-managed-cloud',
        element: BlogThirtyEight,
    },
    {
        path: '/aws-comprehend-and-its-role-in-nlp',
        element: BlogThirtyNine,
    },
    {
        path: '/introduction-to-aws-cli-basic-commands-for-beginners',
        element: BlogForty,
    },
    {
        path: '/building-a-basic-web-application-on-aws',
        element: BlogFortyOne,
    },
    {
        path: '/uploading-and-downloading-files-from-amazon-sw3-using-boto3',
        element: BlogFortyTwo,
    },
    {
        path: '/understanding-the-difference-between-aws-sns-and-sqs',
        element: PageBlogFortyThree,
    },
    {
        path: '/uploading-large-files-upto-5tb-to-amazon-s3-using-boto3-in-python',
        element: PageBlogFortyFour,
    },
    {
        path: '/how-to-deploy-and-host-your-web-app-on-aws-amplify',
        element: PageBlogFortyFive,
    },
    {
        path: '/aws-step-functions-a-practical-guide',
        element: BlogFortySix,
    },
    {
        path: '/getting-started-with-dynamodb-a-practical-approach',
        element: BlogFortySeven,
    },
    { path: '/case-studies', element: CaseList },
    { path: '/case-study-of-gt-pensions-managers', element: GtbPensions },
    {
        path: '/billyronks-selected-cloudplexo-as-aws-advanced-partner',
        element: BillyRonks,
    },
    { path: '/mkobo-uses-cloudplexo-saas-solution', element: Mkobo },
    {
        path: '/phastpay-collaborated-with-cloudplexo-experts-and-leveraging-on-cloudplexo-saas-solution',
        element: PhastPay,
    },
    {
        path: '/alarrt-achieves-enhanced-cost-efficiency-elevated-security-standards-and-a-highly-scalable-and-efficient-infrastructure',
        element: Alarrt,
    },
    { path: '/case-study-in-the-edtech-sector', element: IcanTutors },
    { path: '/liveli-case-study', element: Liveli },
    { path: '/geria-case-study', element: Geria },
    { path: '/ilearncloud-case-study', element: IlearnCloud },
    { path: '/inttix-case-study', element: Inttix },
    { path: '/kobo-case-study', element: Kobo },
    { path: '/jaguar-and-land-rover-case-study', element: Jaguar },
    { path: '/bp-case-study', element: Bp },
    { path: '/rds-ready', element: RDSReady },
    { path: '/aws-lambda-service', element: AWSLambda },
    { path: '/aws-maturity-service', element: AWSMaturityService },
];

class App extends Component {
    Loader = () => {
        return (
            <div id="preloader">
                <div id="status">
                    <div className="spinner">
                        <div className="double-bounce1" />
                        <div className="double-bounce2" />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const helmetContext = {};
        return (
            <HelmetProvider context={helmetContext}>
                <Routes>
                    <Route
                        path="/success-page"
                        element={
                            <Suspense fallback={this.Loader()}>
                                <SplashScreen />
                            </Suspense>
                        }
                    />

                    {routes.map((route, idx) =>
                        route.isWithoutLayout ? (
                            <Route
                                path={route.path}
                                key={idx}
                                element={
                                    <Suspense fallback={this.Loader()}>
                                        <route.element />
                                    </Suspense>
                                }
                            />
                        ) : (
                            <Route
                                path={route.path}
                                key={idx}
                                element={
                                    <Suspense fallback={this.Loader()}>
                                        <Layout>
                                            <route.element />
                                        </Layout>
                                    </Suspense>
                                }
                            />
                        )
                    )}

                    <Route
                        path="*"
                        element={<NotFound />}
                    />
                </Routes>
            </HelmetProvider>
        );
    }
}

export default App;
